module.exports = __webpack_public_path__ + "img/bluebook-2014-report.91de910d.jpg";